// extracted by mini-css-extract-plugin
export default {"petsContainer":"Pets_petsContainer__wGBbb","suppliesContainer":"Pets_suppliesContainer__Vnvw2"};